import React from 'react';
import SearchSimple from "../../../../../components/SearchSimples/SearchSimple";
import CustomTable from "../../../../../components/table/CustomTable";
import DeleteModal from "../../../../Modals/DeleteModal";
import MainInputTableApp from "../Functionality/MainInputTableApp";
import CreateInputModal from "../Modal/CreateInputModal";
import {permissionObj} from "../../../../../Helpers/permission";
import CustomButtonLink from "../../../../../components/buttons/CustomButtonLink";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const MainInputTable = (props) => {
    const {
        deleteModalShow,
        setDeleteModalShow,
        createModalShow,
        setCreateModalShow,
        selectedList,
        setSelectedList
    } = props;

    const {
        t,
        DEV,
        permission,
        tableId,
        searchId,
        thead,
        tbody,
        pagination,
        rowsPerPage,
        setResults,
        option,
        searchElement,
        setSearchElement,
        setSearch,
        setBodyForExport,
        setSimpleSearch,
        deletePermission,
        isAllChecked,
        setIsAllChecked,
        setModified,
        handleCheckboxChange,
        handleDeleteAll,
        deleteSelectedInput
    } = MainInputTableApp({
        selectedList,
        setSelectedList
    });

    return (
        <>
            <SearchSimple
                id={"txt_mit_search"}
                setSearchResults={setResults}
                optionTable={option}
                rowsPerPage={rowsPerPage}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                setBodyForExport={setBodyForExport}
                contractorId={null}
                supplierId={null}
                setSimpleSearch={setSimpleSearch}
                setSearch={setSearch}
            />

            <CustomTable tableId={tableId}
                searchId={searchId}
                checkbox={deletePermission}
                checkboxTitle={"de_/_select_all"}
                isAllChecked={isAllChecked}
                onChangeCheckbox={handleDeleteAll}
                thead={thead}
                tbody={tbody}
                columnActions={false}
                handleCheckboxChange={handleCheckboxChange}
                selectedList={selectedList}
                childrenNotInformation={tbody?.data?.length === 0 ? <>
                     <div className={"warning-text"}>
                         <p>{t("you_haven_not_created_any_input_yet")}</p>
                     </div>
                     { (DEV || permission?.includes(permissionObj?.WEB_HID_CREATE)) &&
                     <CustomButtonLink splitName={false} id={'btn_mit_create'} card={true}
                                       onClick={() => setCreateModalShow(true)}
                                       name={'create_new_input'}/>
                     } </>
                 : undefined
                }
            />

            {pagination()}

            {createModalShow &&
                <CreateInputModal
                    onHide={()=>setCreateModalShow(false)}
                    show={createModalShow}
                    setModified={setModified}
                />
            }

            <DeleteModal
                show={deleteModalShow}
                onHide={() => setDeleteModalShow(false)}
                onClickFn={() => deleteSelectedInput()}
                data={selectedList}
                isReset={setSelectedList}
                isAllReset={setIsAllChecked}
                title_modal={t('delete_input')}
                description={'are_you_sure_you_want_to_delete'}
                element_modal={t('input')}
            />

        </>
    );
};

export default MainInputTable;
